<!--eslint-disable no-mixed-spaces-and-tabs-->
<template>
    <div style="z-index: 0;" class="tank-shadow card card-animate" v-if="Object.keys(props.value).length > 0" :class="props.value.tag.includes('SOMA') ? (parseInt(props.value.level) > 0 ?
        (props.value.level == 1 ? 'bg-soft-success' :
            (
                props.value.level == 2 ? 'bg-soft-warning' : 'bg-soft-danger'
            ))
        : 'bg-soft-info'
    ) : ''
        ">
        <div class="card-body">
            <div class="row">
                <div class="col-12 d-flex justify-content-between d-flex">
                    <i class="bx bxs-star pointer float-start" :class="isFavorite ? 'color-yellow' : ''"
                        @click="favorite(props.value)" v-b-tooltip.hover title="Favorita o tanque"></i>
                    <i class="pointer float-right" :class="hasAlert ? 'mdi mdi-bell-ring' : 'mdi mdi-bell-off-outline'"
                        @click="emitChangeAlert(props.value)" v-b-tooltip.hover
                        title="Ativa o alerta diário deste tanque. Você receberá um &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;e-mail caso ele fique abaixo do ponto de recarga ou em nível crítico!"></i>
                </div>

                <div class="col-12 d-flex justify-content-center mb-3">
                    <h6>
                        <span v-if="props.value.tag && props.value.tag.includes('SOMA')">TANQUE SOMA</span>
                        <span v-else>{{
                            props.value.tag
                        }}</span>
                    </h6>
                </div>
            </div>
            <div class="row">
                <div class="col ">
                    <div class="bottle text-center">
                        <span>
                            <b>{{
                                floatToDecimal((props.value.currentVolume / props.value.capacity) * 100)
                                }} %
                            </b>
                        </span>
                        <div class="water"
                            :style="{ height: (props.value.currentVolume / props.value.capacity) * 92 + '%' }"
                            :class="getTankColor(props.value.level)">
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="ms-1 me-1">
            <div class="col">
                <div class="text-center">
                    <div class="flex-grow-1 overflow-hidden">
                        <p class="fs-12 text-uppercase fw-medium text-muted text-truncate mb-0">
                            Nível Atual
                        </p>
                    </div>
                    <div class="flex-shrink-0">
                        <h5 class="fs-12 mb-0" :class="parseInt(props.value.level) > 0 ?
                                (props.value.level == 1 ? 'text-success' :
                                    (
                                        props.value.level == 2 ? 'text-warning' : 'text-danger'
                                    ))
                                : 'text-info'
                            ">
                            <span class="fs-3">
                                {{
                                    floatToDecimal(props.value.currentVolume)
                                }} {{ props.value.unit }}
                            </span>
                        </h5>
                    </div>
                </div>
                <div class="" style="overflow:visible">
                    <div>
                        <div class="ff-secondary mb-3 text-muted">
                            <span>CAPACIDADE</span>
                            {{ floatToDecimal(props.value.capacity) }} {{
                                props.value.unit
                            }}
                        </div>
                        <span class="fs-12 d-flex mb-1 bold text-primary"> <i class="ri-map-pin-fill m-r-10"></i> {{
                            props.value.customerName ? props.value.customerName.toUpperCase() : ''
                        }}</span>

                        <span class="fs-12 d-flex mb-1 text-muted"> <i class="ri-drop-fill m-r-10"></i> {{
                            tankContent.toUpperCase()
                        }}</span>
                        <span class="fs-12 d-flex mb-2 text-muted"><i class="ri-history-fill m-r-10"></i>
                            <span :class="['d-flex mb-3', isOutdated ? 'text-danger underline' : 'text-muted']">{{
                                props.value.updated
                            }} </span> <i v-if="isOutdated" class="ri-error-warning-fill outdatedWarnIcon"></i>
                        </span>
                    </div>
                </div>
                <div class="text-center mb-3" style="">
                    <router-link class="btn btn-sm btn-primary" :to="'/tanques/' + props.value.id"
                        target="_self"> 
                        <font-awesome-icon :icon="['fa', 'fa-chart-line']" class="menu-icon" />
                        Detalhes
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import { defineProps, defineEmits, computed, ref, onMounted } from 'vue';
import { floatToDecimal } from "./Dependencies/functions";
import moment from 'moment';

let hasAlert = ref(false);

const isOutdated = computed(() => {
    if (props.value.updated) {
        const [datePart, timePart] = props.value.updated.split(' ');

        const updatedTime = moment(`${datePart} ${timePart}`, 'DD/MM/YYYY HH:mm');

        const currentTime = moment();

        const diffInMinutes = currentTime.diff(updatedTime, 'minutes');

        return diffInMinutes > 60;

    } else {
        return null;
    }
});

const tankContent = computed(() => {
    if (props.value.content.includes("AlumÃ­nio")) {
        const str = props.value.content.replace("AlumÃ­nio", "Alumínio");
        return str;
    } else {
        return props.value.content
    }
});

const props = defineProps({
    value: {
        type: Object,
        required: true
    },
    isFavorite: {
        type: Boolean,
        required: true
    },
});

const getTankColor = function (level) {

    level = parseInt(level)

    if (level == 1) {
        return 'bg-success';
    } else if (level == 2) {
        return 'bg-warning'
    } else if (level == 3) {
        return 'bg-danger';
    }

    return 'bg-info';
}

const emit = defineEmits(["removeFavorite", "addFavorite", "changeAlert"]);

const favorite = (value) => {
    if (props.isFavorite) {
        emit('removeFavorite', value)
    } else {
        emit('addFavorite', value)
    }
}
function emitChangeAlert(tank) {
    hasAlert.value = !hasAlert.value;
    emit('changeAlert', tank, hasAlert.value);
}

onMounted(() => {
    hasAlert.value = props.value.hasAlert;
});

</script>

<style scoped>
.tank-shadow {
    box-shadow: 2px 2px 5px 1px rgba(203 203 203 / 75);
    -webkit-box-shadow: 2px 2px 5px 1px rgba(203 203 203 / 75);
    -moz-box-shadow: 2px 2px 5px 1px rgba(203 203 203 / 75);
    /* border: solid #b0aeae 1px; */
}

.float-right {
    float: right !important;
}

.color-yellow {
    color: #F6E300 !important;
}

.tank-container {
    position: relative;
    width: 180px;
    height: 200px;
    background-color: #000;
    border-radius: 30px 30px 0 0;
    /* margin-bottom: 1px; */
}

[data-layout-mode="dark"] {
    .tank-container {
        background-color: #52595e;
    }
}

.fundo {
    left: 5%;
    bottom: 5%;
    width: 90%;
    background: linear-gradient(to bottom,
            #CCCCCC 70%,
            #0ac7fb 30%);
    height: 90%;
    z-index: 10;
    border-radius: 30px 30px 0 0;
}

.bottle span {
    position: relative;
    z-index: 10;
    top: calc(50% - 7px)
}

.card-info-list p {
    white-space: nowrap;
}


.bottle {
    position: relative;
    background: #ccc;
    width: 100%;
    border-radius: 30px 30px 6px 6px;
    height: 200px;
    padding: 6px;
    box-shadow: 3px 3px 3px #efefef;
    margin-bottom: 4px;
}

.water {
    background: lightblue;
    z-index: 1;
    border-radius: 28px 28px 10px 10px;
    position: absolute;
    bottom: 0;
    height: 10%;
    margin: 100% 5% 5% 5%;
    left: 0;
    width: 90%;
    max-height: 100%;
}

.accordion-body {
    background: #F3F3F9;
}

.bottle {
    color: black !important;
}

[data-layout-mode="dark"] {
    .bottle {
        color: black !important;
    }

    .accordion-body {
        background: #1A1D21;
    }
}

.underline {
    text-decoration: underline;
}

.outdatedWarnIcon {
    color: red;
    font-size: 20px;
    margin-left: 8px;
    margin-top: -4px;
}

@media (min-width: 428px) and (max-width: 768px) {
    .water {
        max-height: 80%
    }
}
</style>
